<template>
    <v-row class="search-bar header-container pt-6 gotham-medium">
        <div class="container px-0">
            <div class="pb-0">
                <div class="d-flex jusity-center">
                    <div class="flex">
                        <div class="search-bar-container d-flex align-center p-1 relative">
                            <div class="flex">
                                <ais-instant-search :search-client="searchClient" :middlewares="middlewares"
                                    index-name="products" class="flex">
                                    <ais-configure :clickAnalytics="true" />
                                    <ais-search-box v-model="search" @focus="evtSearchCatalogue"
                                        class="w-100 gotham-book" placeholder="Search full product catalogue..." />
                                    <ais-hits v-show="search !== ''">
                                        <template v-slot="{items, sendEvent}">
                                            <div v-for="product in items" :key="product.id" class="product-list-item"
                                                @click="navigateToProductPage(product, sendEvent)">
                                                <div class="d-flex align-center pa-2">
                                                    <v-col cols="3" md="2" sm="2" class="d-none d-md-block carousel pa-2 product-border"
                                                        v-if="product.images" :class="{'last-image': carousel === product.images.length - 1,'first-image': carousel === 0}">
                                                        <v-carousel hide-delimiters :show-arrows="true" height="75"
                                                            v-model="carousel" v-if="product.images.length > 0">
                                                            <v-carousel-item v-for="image in product.images"
                                                                :key="image.id" :src="image.imageUrl"></v-carousel-item>
                                                        </v-carousel>
                                                        <v-carousel hide-delimiters :show-arrows="false" height="70"
                                                            v-model="carousel" v-else>
                                                            <v-carousel-item src="https://i.stack.imgur.com/y9DpT.jpg">
                                                            </v-carousel-item>
                                                        </v-carousel>
                                                    </v-col>
                                                    <!-- <div class="flex-1 ml-4 gotham-light" v-html="highlightedProductName(product.name)"></div> -->
                                                    <ais-highlight attribute="name" class="flex-1 ml-4 gotham-light"
                                                        :hit="product" highlighted-tag-name="em" />
                                                </div>
                                            </div>
                                        </template>
                                    </ais-hits>
                                </ais-instant-search>
                            </div>
                            <div class="categories-drop-down gotham-medium" v-if="showCategories">
                                <div>
                                    <div class="text-h5 header gotham-medium">Categories</div>
                                    <div class="categories">
                                        <div class="d-flex">
                                            <div>
                                                <div>Restoratives</div>
                                                <div>Endontics</div>
                                                <div>Prosthethics</div>
                                                <div>Perlio</div>
                                                <div>Implant</div>
                                                <div>Orthodontics</div>
                                            </div>
                                            <div>
                                                <div>Restoratives</div>
                                                <div>Endontics</div>
                                                <div>Prosthethics</div>
                                                <div>Perlio</div>
                                                <div>Implant</div>
                                                <div>Orthodontics</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="showCategoriesMenu">
                            <div class="d-flex justify-space-between categories gotham-medium mt-8 relative">
                                <div class="category" v-for="category in categories" :key="category.id">{{category.name}}
                                    <SubMenu :category="category" class="submenu submenu-left-0" />
                                </div>
                                <!-- <div class="category">Anaesthetics
                                    <SubMenu class="submenu submenu-left-1" />
                                </div>
                                <div class="category">Orthodontics
                                    <SubMenu class="submenu submenu-center" />
                                </div>
                                <div class="category">Restoratives
                                    <SubMenu class="submenu submenu-center" />
                                </div>
                                <div class="category">Implants
                                    <SubMenu class="submenu submenu-right-1" />
                                </div>
                                <div class="category">Prosthetics Removable
                                    <SubMenu class="submenu submenu-right-0" />
                                </div> -->
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-row>
</template>
<script>
    import SubMenu from "@/components/Shared/SubMenu/SubMenu.vue";
    const aa = require("search-insights");
    import algoliasearch from "algoliasearch/lite";
    import "instantsearch.css/themes/satellite-min.css";
    import { mapState } from 'vuex';

    aa("init", {
        appId: process.env.ALGOLIA_APP_ID,
        apiKey: process.env.ALGOLIA_ANALYTICS_KEY
    });

    import {
        createInsightsMiddleware
    } from "instantsearch.js/es/middlewares";

    const insightsMiddleware = createInsightsMiddleware({
        insightsClient: aa
    });
    export default {
        props: {
            showCategoriesMenu: {
                default: true,
                type: Boolean
            }
        },
        data() {
            return {
                showCategories: false,
                middlewares: [insightsMiddleware],
                searchClient: algoliasearch(
                    process.env.ALGOLIA_APP_ID,
                    process.env.ALGOLIA_API_KEY
                ),
                query: "",
                search: "",
                carousel: 1
            }
        },
        computed: {
            ...mapState({
                categories: state => state.category.categories
            })
        },
        mounted() {
            this.$store.dispatch('category/GET_CATEGORIES');
        },
        components: {
            SubMenu
        },
        methods: {
            navigateToProductPage(item, sendEvent) {
                this.evtCatalogueItemSelected(item);
                sendEvent("click", item, "Search Result Clicked");
                this.$router.push({
                    name: "Product",
                    params: {
                        id: this.convertToSlug(item.name) + "-" + item.id
                    }
                });
            },
            convertToSlug(Text) {
                return Text.toLowerCase()
                    .replace(/[^\w ]+/g, "")
                    .replace(/ +/g, "-");
            },
        }

    }
</script>
<style lang="scss"  src="./SearchBar.scss"></style>